export default __webpack_public_path__ + "fonts/Gotham-Bold.039cbaec69e349e3507b5df47dded7c9.woff";